import { render, staticRenderFns } from "./Qualification.vue?vue&type=template&id=4b82ae66&scoped=true&"
import script from "./Qualification.vue?vue&type=script&lang=js&"
export * from "./Qualification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b82ae66",
  null
  
)

export default component.exports